import * as React from 'react';
import * as Redux from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import {
  deletePeriodosAcademicosAction,
  allPeriodosAcademicosAction,
  setActivoPeriodosAcademicosAction,
} from '../PeriodosAcademicosAction';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import ActionsListWidget from '../../../../widgets/ActionsList';
import { LoadingWidget } from '../../../../widgets';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import { useNotification } from '../../../../helpers/Notification';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { PARAMS_PERIODOS_ACADEMICOS } from '../PeriodosAcademicosReducer';

const ListadoPeriodosAcademicos = ({
  isDelete = false,
  setIsDelete = () => {},
}) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const periodosAcademicosStore = Redux.useSelector(
    (state) => state.periodosAcademicos,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        idEntidad: entidadesStore.activo.id,
      };
      dispatch({ type: PARAMS_PERIODOS_ACADEMICOS, payload });
      if (
        periodosAcademicosStore.all &&
        periodosAcademicosStore.all.length === 0
      ) {
        await allPeriodosAcademicosAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let dataRows = [];
    periodosAcademicosStore.all.forEach((el) => {
      dataRows.push({
        ...el,
        estatus: el.estatus.nombre,
      });
    });
    setRows(dataRows);
  }, [periodosAcademicosStore.all]);

  const _handleEditClick = async (id) => {
    setIsDelete(false);
    const data = periodosAcademicosStore.all.find((el) => el.id === id);
    await setActivoPeriodosAcademicosAction(dispatch, data);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deletePeriodosAcademicosAction(
      { dispatch, notify },
      periodosAcademicosStore.activo.id,
      periodosAcademicosStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" alignItems="center">
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
                mr="10px"
              >
                {value}
              </NameComponent>
              {periodosAcademicosStore.activo?.id === tableMeta.rowData[0] &&
                !isDelete && (
                  <Chip
                    label="Editando"
                    size="small"
                    color="info"
                    sx={{ mr: 1 }}
                  />
                )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.desde.name,
      label: CONST.desde.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.hasta.name,
      label: CONST.hasta.label,
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = periodosAcademicosStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoPeriodosAcademicosAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={periodosAcademicosStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {periodosAcademicosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {periodosAcademicosStore.activo.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoPeriodosAcademicos;
